var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-navbar-brand',{staticClass:"mb-0",attrs:{"href":"https://www.moonriselabs.com"}},[_c('img',{attrs:{"alt":"logo","src":"/logo.png","height":"25"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }